import React from 'react';
import clsx from 'clsx';

/** Abschnittsueberschrift der oeffentlichen Seiten: kleine Kennzeile, Titel und Einleitung. */
export const SectionHeader: React.FC<{
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'center' | 'left';
}> = ({ eyebrow, title, subtitle, align = 'center' }) => (
  <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-xl'}>
    {eyebrow && <p className="text-sm font-semibold uppercase tracking-[0.14em] text-primary-300">{eyebrow}</p>}
    <h2 className={clsx('text-balance text-3xl font-bold tracking-tight text-dark-50 sm:text-4xl', eyebrow && 'mt-3')}>
      {title}
    </h2>
    {subtitle && (
      <p className={clsx('mt-4 text-base leading-relaxed text-dark-300 sm:text-lg', align === 'center' && 'mx-auto max-w-2xl')}>
        {subtitle}
      </p>
    )}
  </div>
);
